module.exports = __webpack_public_path__ + "img/img30.5622300f.svg";